import Changeset from 'ember-changeset';
import mailerTemplateVersionValidations from 'garaje/validations/mailer-template-version';
import lookupValidator from 'ember-changeset-validations';

export default function (mailerTemplateVersion) {
  const validator = lookupValidator(mailerTemplateVersionValidations);

  return new Changeset(mailerTemplateVersion, validator, mailerTemplateVersionValidations);
}
